
import React, { useState, useEffect } from "react";
import { DropdownButton, Dropdown, Table, Row, Col, Card } from 'react-bootstrap';
import { CFormSelect } from '@coreui/react';
import { Link, NavLink } from 'react-router-dom';
import Footer from "../components/Footer";

// CSS 
import "../../src/assets/Gallery.css";

// IMAGES 
import main_logo from '../assets/images/UPG_site_logo.png';
import dummy_gallery_img1 from '../assets/images/avatars/user.jpg';
import dummy_gallery_img2 from '../assets/images/avatars/6.jpg';
import dummy_gallery_img3 from '../assets/images/avatars/4.jpg';
import dummy_gallery_img4 from '../assets/images/avatars/7.jpg';
import { GetTournamentList, GetGallery, getSetting } from '../API/admin'
import Loader from "./admin/Common/Loader";
import { GetTeams } from '../API/auth'
import { Profile, PhotoAPI } from '../API/player'
import { FilterDynamicText } from '../API/admin';
import Swal from "sweetalert2";
import { useSnackbar } from 'notistack'

function PGallery() {

    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [dynamicHeading, setDynamicHeading] = useState({});
    const [loginUser, setLoginUser] = useState(null)
    let [loaderStatus, setloaderStatus] = useState(true)
    const [SelectedTournament, setSelectedTournament] = useState(null)
    const [SelectedTeam, setSelectedTeam] = useState(null)
    const [SelectedGame, setSelectedGame] = useState('badminton')
    const [tournamentList, setTournamentList] = useState([])
    const [teams, setTeams] = useState([])
    const [GalleryImages, setGalleryImages] = useState([])
    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
    const [TournamentOff, setTouramentOff] = useState(false);

    useEffect(() => {

        let callAPI = async () => {
            let res = await Profile()
            console.log(res)
            if (res.statusCode == 403) {
                setLoginUser(null)
                setloaderStatus(false)
            } else {
                setLoginUser(res.data)
                setloaderStatus(false)
            }
        }

        let tournamentListApi = async () => {
            let res = await GetTournamentList()
            if (res.status) {
                setloaderStatus(false)
                setTournamentList(res.data)
                setSelectedTournament(res.data[0]._id)
            } else {
                setloaderStatus(false)
                enqueueSnackbar('Tournament not found', {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                })
            }
        }

        let getTeamsAPI = async () => {
            let res = await GetTeams()
            if (res.status) {
                setTeams(res.data)
                setSelectedTeam(res.data[0].id.toString())
            } else {
                setTeams([])
                setSelectedTeam(null)
            }
        }
        getTeamsAPI()
        callAPI()
        tournamentListApi()
    }, [])
    useEffect(() => {
        let callAPI = async () => {
            let res = await getSetting()

            if (res.status) {
                res.data.map((entry, index) => {
                    if (entry.value == 'false' && entry.name === 'tournament_register') {
                        setTouramentOff(true);
                    }
                })
            } else {
                // setIsOn(null);
                enqueueSnackbar('unable to fetch setting', {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                })
            }
        }
        callAPI()
    }, [])
    useEffect(() => {
        setloaderStatus(true)

        let PhotoGalleryAPI = async () => {
            var PhotoImage = [];
            let formData = {
                'tournament_id': SelectedTournament,
                'team_id': SelectedTeam,
                'game_type': SelectedGame
            }
            let res = await GetGallery(formData)
            if (res.status) {
                setloaderStatus(false)

                res.data.map((entry, index) => {
                    entry.images.map((image, index) => {

                        PhotoImage.push(image)
                    })
                })
            }

            console.log(PhotoImage)
            setGalleryImages(PhotoImage)
            setloaderStatus(false)
        }
        if (SelectedTournament != null && SelectedTeam != null && SelectedGame != null)
            PhotoGalleryAPI()
    }, [SelectedTournament, SelectedTeam, SelectedGame])
    const handleChange = event => {
        console.log(event.target)
        const selectedId = event.target.value
        setSelectedTournament(selectedId)
        // setloaderStatus(true)
    }

    const handleTeamChange = e => {
        setSelectedTeam(e.target.value)
    }

    const handleGameChange = e => {
        setSelectedGame(e.target.value)
    }

    const openLightbox = (index) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? GalleryImages.length - 1 : prevIndex - 1
        );
    };

    const nextImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === GalleryImages.length - 1 ? 0 : prevIndex + 1
        );
    };

    //  Photo/Video Request hit 
    useEffect(() => {

        let callAPIDynamictext = async () => {
            let formData = {
                "data": null
            }
            let res = await FilterDynamicText(formData);
            if (res.data.status) {
                console.log(res.data.data)
                setDynamicHeading(res.data.data)
            }
        }
        callAPIDynamictext();
    }, [])

    let PhotoReq = async () => {
        console.log("Hello")
        Swal.fire({
            title: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.title
                : "Request photo/video?",
            text: dynamicHeading.request_photo_video
                ? dynamicHeading.request_photo_video.value : "Request photo/video?",
            // icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send Request",
            cancelButtonText: "Close"

        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await PhotoAPI();
                if (res.data.status) {
                    if (res.data.NoMatch) {
                        enqueueSnackbar('You have not played any matches yet', {
                            variant: 'error', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    } else {

                        enqueueSnackbar('Request was sent successfully', {
                            variant: 'success', action: (key) => (
                                <button className='toast_close_btn'
                                    onClick={() => {
                                        // Close the Snackbar
                                        closeSnackbar(key);
                                    }}
                                >
                                    X
                                </button>
                            ),
                        })

                    }
                } else {
                    enqueueSnackbar('Unable to send request at the moment', {
                        variant: 'error', action: (key) => (
                            <button className='toast_close_btn'
                                onClick={() => {
                                    // Close the Snackbar
                                    closeSnackbar(key);
                                }}
                            >
                                X
                            </button>
                        ),
                    })
                }

            }
        });

    }

    //    My profile navigation
    let Myprofilenavigate;
    if (loginUser) {
        switch (loginUser.role) {
            case "participant":
                Myprofilenavigate = "/participant/profile";
                break;
            case "admin":
                Myprofilenavigate = "/admin/profile";
                break;
            case "scorer":
                Myprofilenavigate = "/scorer/profile";
                break;
            default:
                Myprofilenavigate = "/";
                break;
        }
    } else {
        Myprofilenavigate = "/"; // Redirect to login if user is not logged in
    }


    const formatTitle = (text) => {
        return text
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
      };
    return (
        <>
            {loaderStatus ? <Loader /> : null  }
            <div className="main_div_heigtport">
                <header>
                    <nav className="navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage">
                        <a className="navbar-brand" href="/">
                            <img src={main_logo} alt="Logo" />
                        </a>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNav"
                            aria-controls="navbarNav"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            style={{ background: '#B2022F' }}
                        >
                            {/* <span className="navbar-toggler-icon" /> */}
                            <i class="bi bi-list" style={{ color: "#fff", fontSize: "25px" }}></i>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav ms-auto nav-list">
                                {
                                    loginUser != null ? (
                                        <>
                                         <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                            <li className='nav-item'
                                                style={{ display: (loginUser != null) ? "block" : "none" }} >
                                                <NavLink className='nav_page_btn mobile_displa_dashboard' to='/dashboard' activeClassName='active'>
                                                    Dashboard
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                {/* Changed to NavLink */}
                                                <NavLink className='nav_page_btn' to='/Results' activeClassName='active'>
                                                    Results
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                {/* Changed to NavLink */}
                                                <NavLink className='nav_page_btn' to='/photo-gallery' activeClassName='active'>
                                                    Gallery
                                                </NavLink>
                                            </li>
                                            <li className='nav-item'>
                                                {/* Changed to NavLink */}
                                                <NavLink className='nav_page_btn' to='/contact' activeClassName='active'>
                                                    Get in Touch
                                                </NavLink>
                                            </li>
                                            <li className="nav-item dropdown">
                                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <img
                                                        src={loginUser.profile_image !== undefined ?
                                                            IMAGE_URL + "user/" + loginUser.profile_image : IMAGE_URL + "blank_user.png"}
                                                        alt="Profile"
                                                        className="rounded-circle"
                                                        style={{
                                                            width: "60px",
                                                            height: "60px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-end new_header_dropdown" aria-labelledby="navbarDropdown">
                                                    <li className='mobile_displa_popup_dashboard'>
                                                        <NavLink className="dropdown-item" to="/dashboard">Dashboard</NavLink>
                                                    </li>
                                                    <li>
                                                        <NavLink className="dropdown-item" to={Myprofilenavigate}>My Profile</NavLink>
                                                    </li>
                                                    <li style={{ display: (loginUser.role === "participant") ? "block" : "none" }}
                                                        onClick={() => PhotoReq()}>
                                                        <Link className="dropdown-item"> Request Photo/Video</Link>
                                                    </li>
                                                    <li>
                                                        <Link className="dropdown-item" to="/logout">Logout</Link>
                                                    </li>
                                                </ul>
                                            </li>
                                        </>
                                    ) : (
                                        <>
                                         <li className='nav-item'>
                                            <a className='nav_page_btn' href='/'>
                                                Home
                                            </a>
                                        </li>
                                            <li className="nav-item">
                                                <NavLink className='nav_page_btn' to='/Results' activeClassName='active'>
                                                    Results
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink className='nav_page_btn' to='/photo-gallery' activeClassName='active'>
                                                    Gallery
                                                </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                <NavLink className='nav_page_btn' to='/contact' activeClassName='active'>
                                                    Get in Touch
                                                </NavLink>
                                            </li>
                                        
                                                <li className="nav-item">
                                                    {/* Changed to NavLink */}
                                                    <NavLink className="signup_btn" to="/register" activeClassName='active'>
                                                        Register Now
                                                    </NavLink>
                                                </li>
                                            
                                            <li className="nav-item">
                                                <NavLink className="login_btn" to="/login" activeClassName='active'>
                                                    Login
                                                </NavLink>
                                            </li>
                                        </>
                                    )
                                }
                            </ul>
                        </div>
                    </nav>
                </header>
                <section className='headre_bg_div'></section>
                <div className='container-fluid flex-grow-1' style={{ background: "#000", }}>
                    <div className='container-lg text-white'>
                        <section className="gallery_sec py-4">
                            <h3 className="all_new_pages_heading"> GALLERY</h3>
                            <div className="galry_filter_btns_main_div">
                                {/* <div className="col-lg-6 col-md-5"> */}
                                {/* <div className="d-flex justify-content-between filtr_two_btn_main"> */}
                                {/* static city button  */}
                                <div className="filter_txt_btn">
                                    <div className='gallery_btn_heading_txt'>City</div>
                                    <CFormSelect
                                        aria-label='Default select example '
                                        // onChange={handleTeamChange}
                                        className='bg-dark text-white gallry_slct_btn'
                                    >
                                        <option value='city-1' >Melbourne </option>
                                    </CFormSelect>
                                </div>
                                <div className="filter_txt_btn">
                                    <div className='gallery_btn_heading_txt'> Tournament  </div>
                                    <CFormSelect
                                        aria-label='Default select example'
                                        //   onChange={handleRound}
                                        onChange={handleChange}
                                        className='bg-dark text-white gallry_slct_btn'
                                    >


                                        {tournamentList.length
                                            ?
                                            <>
                                                <option value={tournamentList[0]._id.toString()} selected>
                                                    {tournamentList[0].name}
                                                </option>
                                                {
                                                    tournamentList.slice(1).map((tournament, index) => (
                                                        <option
                                                            key={index + 1}
                                                            value={tournament._id.toString()}
                                                        >
                                                            {tournament.name}
                                                        </option>
                                                    ))

                                                }
                                            </>
                                            : ''}
                                    </CFormSelect>
                                </div>

                                {/* </div> */}
                                {/* </div> */}
                                {/* <div className="col-lg-6 col-md-7"> */}
                                {/* <div className="d-flex justify-content-between filtr_two_btn_main"> */}
                                <div className="filter_txt_btn">
                                    <div className='gallery_btn_heading_txt'> Games  </div>
                                    <CFormSelect
                                        aria-label='Default select example'
                                        onChange={handleGameChange}
                                        className='bg-dark text-white  gallry_slct_btn'
                                    >
                                        <option value='badminton' >Badminton</option>
                                        <option value='table_tenis' >Table Tennis</option>
                                        {/* <option value='bowling' >Bowling</option>
                                        <option value='2k_run'> 2K Run</option> */}
                                    </CFormSelect>
                                </div>
                                <div className="filter_txt_btn">
                                    <div className='gallery_btn_heading_txt'> Team  </div>
                                    <CFormSelect
                                        aria-label='Default select example'
                                        onChange={handleTeamChange}
                                        className='bg-dark text-white gallry_slct_btn '
                                    >
                                        {teams.length > 0 ? (
                                            <>
                                                <option value={teams[0].id.toString()} selected>
                                            {formatTitle(teams[0].domain)}

                                                </option>
                                                {teams.slice(1).map((entry, index) => (
                                                    <option key={index + 1} value={entry.id.toString()}>
                                            {formatTitle(entry.domain)}

                                                    </option>
                                                ))}
                                            </>
                                        ) : null}
                                    </CFormSelect>
                                </div>
                                {/* </div> */}
                                {/* </div> */}
                            </div>

                            <div className="py-4">
                                <Row style={{minHeight:"45vh", overflowY: "auto"}}>
                                    {
                                        GalleryImages.length > 0 ? (
                                            GalleryImages.map((image, index) => (
                                                <Col lg={3} md={4} xs={4}>
                                                    {/* <div key={index} className={`gallery-item gallery-item-${index + 1}`}>
                                                        <img
                                                            src={`${IMAGE_URL}gallery/${image}`}
                                                            alt={`Gallery Image ${index + 1}`}
                                                            onClick={() => openLightbox(index)}
                                                        />
                                                    </div> */}
                                                    <div
                                                        className={`gallery-item gallery-item-${index + 1}`}
                                                        style={{
                                                            backgroundImage: `url(${IMAGE_URL}gallery/${image})`,
                                                            backgroundSize: 'cover',
                                                            // backgroundPosition: 'center', // To center the image within the div
                                                        }}
                                                        onClick={() => openLightbox(index)}
                                                    >

                                                    </div>
                                                </Col>
                                            ))
                                        ) :
                                            <>
                                                <div className='d-flex align-items-center ps-4'>
                                                    <div className='nodata_row '>
                                                        No photos available
                                                    </div>
                                                </div>
                                            </>
                                    }
                                </Row>

                                {lightboxOpen && GalleryImages.length > 0 && (
                                    <div className="lightbox">
                                        <span className="close" onClick={closeLightbox}>&times;</span>
                                        <button className="prev" onClick={prevImage}>&lt;</button>
                                        <img src={`${IMAGE_URL}gallery/${GalleryImages[currentIndex]}`} alt="Lightbox" />
                                        <button className="next" onClick={nextImage}>&gt;</button>
                                    </div>
                                )}

                            </div>
                        </section>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default PGallery;


